import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Form, Input, Button, Space, Switch, Alert,
} from 'antd';

import PageContent from '../../components/Layout/PageContent';
import {
  currentMegaphoneBannerGet, currentMegaphoneBannerUpdate, megaphoneBannerCreate,
} from '../../redux/actions/megaphoneBanner';
import { loadingSelector, dataSelector, errorsSelector } from '../../redux/selectors/megaphoneBanner';
import { validateMaxLength } from '../../helpers/form';

const MegaphoneBannerForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const loading = useSelector(loadingSelector);
  const errors = useSelector(errorsSelector);
  const megaphoneBanner = useSelector(dataSelector);

  const onPublish = (values) => {
    if (megaphoneBanner.id) {
      dispatch(currentMegaphoneBannerUpdate(megaphoneBanner.id, values));
    } else {
      dispatch(megaphoneBannerCreate(values));
    }
  };

  useEffect(() => {
    dispatch(currentMegaphoneBannerGet());
  }, [dispatch]);

  useEffect(() => {
    form.setFieldsValue(megaphoneBanner);
  }, [form, megaphoneBanner]);

  return (
    <PageContent title="Megaphone Banner" breadcrumb={['Web', 'Megaphone Banner']} loading={loading}>
      {errors && <Alert message={errors} type="error" showIcon closable />}
      <Form
        form={form}
        layout="vertical"
        initialValues={megaphoneBanner}
        validateMessages={{ required: 'This field is required', types: { url: 'Enter a valid url' } }}
        onFinish={onPublish}
        scrollToFirstError
      >
        <Form.Item
          label="Title (Bold)"
          name="title"
          extra="45 characters limit"
          rules={[{
            validator: validateMaxLength,
            maxLength: 45,
          }]}
        >
          <Input size="large" placeholder="Title copy" />
        </Form.Item>
        <Form.Item
          label="Subtext"
          name="subText"
          extra="170 characters limit"
          rules={[{
            validator: validateMaxLength,
            maxLength: 170,
          }]}
        >
          <Input.TextArea placeholder="Subtext copy" />
        </Form.Item>
        <Form.Item name="published" valuePropName="checked">
          <Switch />
        </Form.Item>
        <span className="ant-switch-label">Publish Live</span>
        <Form.Item wrapperCol={{ gutter: 16 }} style={{ marginTop: 50 }}>
          <Space>
            <Button type="primary" size="large" htmlType="submit">Publish</Button>
            <Button type="secondary" size="large">Review</Button>
            <Button type="link" size="large">Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </PageContent>
  );
};

MegaphoneBannerForm.propTypes = {

};

export default MegaphoneBannerForm;
